import { NgModule } from '@angular/core'
import { RouterModule, Routes } from '@angular/router'
import { PersonaComponent } from './tools/persona/persona.component'

const routes: Routes = [
  {
    path: '',
    component: PersonaComponent,
  },
  {
    path: 'tools/persona',
    component: PersonaComponent,
  },
]

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
